import React from "react";
import { Empty, Table } from "antd";
import {
  OVERDUE_ELLIPSIS_COLUMN,
  formatOverdueCellValue,
  renderOverdueEllipsisCell,
} from "../utils/overdueUtils";
import {
  DATA_OPS_TABLE_PAGINATION,
  DATA_OPS_TABLE_SCROLL_Y,
} from "../utils/utils";

const RCA_GROUP_COLUMNS = [
  {
    title: "Test Category",
    dataIndex: "categoryName",
    key: "categoryName",
    ellipsis: OVERDUE_ELLIPSIS_COLUMN,
    render: renderOverdueEllipsisCell,
  },
  {
    title: "Active",
    dataIndex: "activeCount",
    key: "activeCount",
    width: 120,
    render: formatOverdueCellValue,
  },
  {
    title: "Completed",
    dataIndex: "completedCount",
    key: "completedCount",
    width: 120,
    render: formatOverdueCellValue,
  },
  {
    title: "Not Started",
    dataIndex: "notStartedCount",
    key: "notStartedCount",
    width: 120,
    render: formatOverdueCellValue,
  },
  {
    title: "In Progress",
    dataIndex: "inProgressCount",
    key: "inProgressCount",
    width: 120,
    render: formatOverdueCellValue,
  },
  {
    title: "On-Hold",
    dataIndex: "onHoldCount",
    key: "onHoldCount",
    width: 120,
    render: formatOverdueCellValue,
  },
];

/**
 * RCA category groups table.
 * Click a category row to open the RCA list modal (no expand — details live in the modal).
 */
export default function RcaTable({
  groups,
  loading,
  summaryCount = null,
  onViewGroup,
}) {
  return (
    <Table
      sticky
      bordered
      className="DataOpsAnalytics__Table"
      size="middle"
      rowKey="rowKey"
      loading={loading}
      columns={RCA_GROUP_COLUMNS}
      dataSource={groups}
      onRow={onViewGroup
        ? (group) => ({
          onClick: () => onViewGroup(group),
          className: "DataOpsAnalytics__ClickableRow",
        })
        : undefined}
      pagination={{
        ...DATA_OPS_TABLE_PAGINATION,
        defaultPageSize: 100,
        showTotal: (total) => {
          if (summaryCount) {
            return `${total} categories · ${summaryCount.active} active · ${summaryCount.completed} completed · ${summaryCount.notStarted} not started · ${summaryCount.inProgress} in progress · ${summaryCount.onHold} on-hold · ${summaryCount.total} total`;
          }
          return `${total} categories`;
        },
      }}
      scroll={{ y: DATA_OPS_TABLE_SCROLL_Y }}
      locale={{
        emptyText: (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data" />
        ),
      }}
    />
  );
}
